// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty } from '@shared/commons/DynProperty';
import { Resources } from '@shared/localizations/Resources';
import { EntitlementProductRequestType } from '@shared/commons/cache/Entitlement/EntitlementPrimitives';
import { EntitlementProductRequestStatus, EntitlementProductRequestStatusMap, EntitlementProductRequestTypeMap } from '@shared/commons/cache/Entitlement/EntitlementPrimitives';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { QuickTableEditingInfo } from '../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { StringUtils } from '@shared/utils/StringUtils';
import { DataCache } from '@shared/commons/DataCache';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { ThemeManager } from '../misc/ThemeManager';
export class EntitlementProductsItem extends BaseItem {
    constructor(requestData, sessionSettings) {
        super(sessionSettings);
        this.requestData = requestData;
        this.QuickTableEditingInfoMap[5] = (function () {
            return new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
        })();
    }
    getQuickTableCellForeground(column) {
        const colors = ThemeManager.colors;
        if (column === 1 && !isNullOrUndefined(this.requestData)) {
            switch (this.requestData.ReqType) {
                case EntitlementProductRequestType.Subscribe:
                    return colors.tableSubscribeForeground;
                case EntitlementProductRequestType.Unsubscribe:
                    return null;
                default:
                    return null;
            }
        }
        else if (column === 2 && !isNullOrUndefined(this.requestData)) {
            switch (this.requestData.ReqStatus) {
                case EntitlementProductRequestStatus.Processing:
                    return colors.tableProcessingForeground;
                case EntitlementProductRequestStatus.Approved:
                    return colors.tableApprovedForeground;
                case EntitlementProductRequestStatus.Rejected:
                    return colors.tableRejectedForeground;
                case EntitlementProductRequestStatus.Canceled:
                    return colors.tableCanceledForeground;
                default:
                    return null;
            }
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
    ColumnCount() {
        return EntitlementProductsItem.columnsParams.length;
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let formattedValue = '';
        switch (column) {
            case 0:
                formattedValue = value ? value.toString() : '';
                break;
            case 1:
                formattedValue = EntitlementProductRequestTypeMap[value];
                break;
            case 2:
                formattedValue = Resources.getResource('panel.product.ProductStatus.Value.' + EntitlementProductRequestStatusMap[value]);
                break;
            case 3:
                formattedValue = !value ? '' : value.toString();
                break;
            case 4:
                formattedValue = DateTimeUtils.FormatToDateAndTime(new Date(value));
                break;
            default:
                formattedValue =
                    value === null || value === '' || value === undefined || Number.isNaN(value)
                        ? StringUtils.NOT_AVAILABLE
                        : value.toString();
        }
        return new ColumnData(value, formattedValue);
    }
    getColumnValue(column) {
        const requestData = this.requestData;
        switch (column) {
            case 0:
                return requestData.Name;
            case 1:
                return requestData.ReqType;
            case 2:
                return requestData.ReqStatus;
            case 3:
                return requestData.Comment;
            case 4:
                return requestData.ReqTime;
            case 5: {
                const product = DataCache.EntitlementManager.ProductsCache[requestData.Id];
                if (!product) {
                    return null;
                }
                const value = requestData.ReqStatus == EntitlementProductRequestStatus.Processing &&
                    product.ReqStatus == EntitlementProductRequestStatus.Processing &&
                    product.ReqTime == requestData.ReqTime;
                return value ? 1 : null;
            }
            default:
                return 0;
        }
    }
    GetColumnParams(column) {
        const result = EntitlementProductsItem.columnsParams[column];
        result.Hidden = result.DefaultHidden;
        return result;
    }
}
EntitlementProductsItem.columnsParams = [
    new ColumnParams('panel.product.ProductName', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.product.ProductType', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.product.ProductStatus', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.product.Comment', 70, QTAlignment.Left, TableTotalsVisibility.None, false, false),
    new ColumnParams('panel.product.DateTime', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.product.Cancel', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false)
];
EntitlementProductsItem.ListMenuIndex = [
    'panel.product.ProductName',
    'panel.product.ProductType',
    'panel.product.ProductStatus',
    'panel.product.Comment',
    'panel.product.DateTime',
    'panel.product.Cancel'
];
